export default __webpack_public_path__ + "static/img/img_fmzl.b63b73b.png";